import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import Namemowakel from "../../popups/Namemowakel/Namemowakel";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Typemowkel from "../../popups/Typemowkel/Typemowkel";
import Geha from "../../popups/geha/geha";
import Tawkelstate from "../../popups/Tawkelstate/Tawkelstate";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { GetAllClientsMowakelAction } from "../../../../redux/actions/ClientAction";
import {
  CreateAgencyAction,
  DeleteAgencyAction,
  GetAllAgencyAction,
  UpdateAgencyAction,
} from "../../../../redux/actions/AgencyAction";
import { GetAllAgencyStatusAction } from "../../../../redux/actions/AgencySatatusAction";
import { GetAllAgencyTypeAction } from "../../../../redux/actions/AgencyTypeAction";
import { GetAllAgencyDestinationAction } from "../../../../redux/actions/AgencyDestinationAction";
import notify from "../../../Notifcation";
import axios from "axios";
import fileDownload from "js-file-download";
import Pagination from "../../../Utility/Pagination/Pagination";
import { ToastContainer } from "react-toastify";
import { useDownloadExcel } from "react-export-table-to-excel";
import TawkelPrint from "../TawkelPrint";
const filter = createFilterOptions();

const Enter = ({
  NoteImg,
  setNoteImg,
  userData,
  NameMowakel,
  setNameMowakel,
  SefaMowakel,
  setSefaMowakel,
  NameWakel,
  setNameWakel,
  NumberTawkel,
  setNumberTawkel,
  Cahr,
  setCahr,
  Year,
  setYear,
  TypeTwakel,
  setTypeTwakel,
  Gehaa,
  setGehaa,
  DateTawkel,
  setDateTawkel,
  Gharad,
  setGharad,
  TawkelStatus,
  setTawkelStatus,
  Note,
  setNote,
  setTawkelID,
  TawkelID,
  setSelectedFile,
  selectedFile,
}) => {
  const tableRef = useRef("");
  const [showName, setshowName] = useState(false);
  const [showTypet, setshowTypet] = useState(false);
  const [showVerify, setshowVerify] = useState(false);
  const [Search, setSearch] = useState("");
  const [showState, setshowState] = useState(false);
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const myDivRefWorkcom = useRef();
  const ALLMowakel = useSelector((state) => state.ClientR.GetClientsMo);
  const ALL = useSelector((state) => state.AgencyR.getAgency);
  const ALLGeha = useSelector(
    (state) => state.AgencyDestinationR.getAgencyDestination
  );

  const ALLStatus = useSelector((state) => state.AgencyStatusR.getAgencyStatus);
  const ALLType = useSelector((state) => state.AgencyTypeR.getAgencyType);
  const PageSize = 7;
  const dispatch = useDispatch();
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "ادارة التوكيلات",
    sheet: "ادارة التوكيلات",
  });
  useEffect(() => {
    dispatch(GetAllAgencyAction(`SearchTerm=${Search}&PageSize=${PageSize}`));
  }, [Search]);
  // useEffect(() => {
  //   if (ALL && ALL.TotalPages) {
  //     setContt(ALL.TotalPages);
  //   }
  // }, [ALL]);
  useEffect(() => {
    dispatch(GetAllClientsMowakelAction());
    dispatch(GetAllAgencyStatusAction());
    dispatch(GetAllAgencyTypeAction());
    dispatch(GetAllAgencyDestinationAction());
  }, []);
  const handlePrint = useReactToPrint({
    content: () => myDivRefWorkcom.current,
  });

  const [showDelete, setshowDelete] = useState(false);
  const onPress = async (page) => {
    await dispatch(
      GetAllAgencyAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const current = ALL?.CurrentPage;

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setTawkelID(itemid);
  };

  const handleCloseName = () => setshowName(false);
  const handleShowName = () => setshowName(true);

  const handleCloseTypet = () => setshowTypet(false);
  const handleShowTypet = () => setshowTypet(true);

  const handleCloseVerify = () => setshowVerify(false);
  const handleShowVerify = () => setshowVerify(true);

  const handleCloseState = () => setshowState(false);
  const handleShowState = () => setshowState(true);
  const converterqoma = (msg) => {
    if (msg !== null) {
      let parts = msg.split("-");
      return parts;
    }
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAgencyAction(TawkelID));
    setLoading(false);

    setshowDelete(false);
    setIsPress(false);
    setTawkelID("");
    setSefaMowakel("");
    setNote("");
    setNameWakel("");
    setNameMowakel("");
    setDateTawkel("");
    setGharad("");
    setYear("");
    setCahr("");
    setNumberTawkel("");
    setTypeTwakel("");
    setTawkelStatus("");
    setGehaa("");
    setSelectedFile("");
    setBase64("");
    setIsEdit(false);
    setIsPress(false);
    setLoading(false);
  };

  const [FileeBase64, setBase64] = useState("");

  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";
    if (userData.UsedSize >= userData.SubscriptionSizeOnS3) {
      notify(
        "تم استهلاك باقة الارشيف لزيادة السعة التخزينية التواصل معنا",
        "warn"
      );
      return;
    }
    input.onchange = (e) => {
      setSelectedFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };
      reader.readAsDataURL(e.target.files[0]);
    };
    // }

    input.click();
  }
  const deleteFile = () => {
    setSelectedFile("");
    setBase64("");
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (NameMowakel === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    if (userData.SubscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.SubscriptionType === "User-not-subscriped" &&
      ALL.Data &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 توكيلات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.SubscriptionType === "User-not-subscriped" &&
      current > 1 &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 توكيلات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.SubscriptionType === "Subscription-not-approved" &&
      current > 1 &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 توكيلات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.SubscriptionType === "Subscription-not-approved" &&
      ALL.Data &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 توكيلات إشترك للتفعيل ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("AgencyDescription", SefaMowakel);
    formData.append("AgencyName", NameWakel);
    formData.append("AgencyNumber", NumberTawkel + "-" + Cahr + "-" + Year);
    formData.append("AgencyDate", DateTawkel);
    formData.append("AgencyPurpose", Gharad);
    formData.append(
      "ClientId",
      NameMowakel && NameMowakel.Id !== 0 ? NameMowakel.Id : ""
    );
    formData.append(
      "AgencyTypeId",
      TypeTwakel && TypeTwakel.Id !== 0 ? TypeTwakel.Id : ""
    );
    formData.append(
      "AgencyStatusId",
      TawkelStatus && TawkelStatus.Id !== 0 ? TawkelStatus.Id : ""
    );
    formData.append(
      "AgencyDestinationId",
      Gehaa && Gehaa.Id !== 0 ? Gehaa.Id : ""
    );
    formData.append("File", selectedFile);
    formData.append("FileDescription", NoteImg);

    await dispatch(CreateAgencyAction(formData));
    setSefaMowakel("");
    setNote("");
    setNameWakel("");
    setNameMowakel("");
    setDateTawkel("");
    setGharad("");
    setYear("");
    setCahr("");
    setNumberTawkel("");
    setTypeTwakel("");
    setTawkelStatus("");
    setGehaa("");
    setSelectedFile("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (NameMowakel === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("Id", TawkelID);
    formData.append("AgencyDescription", SefaMowakel);
    formData.append("AgencyName", NameWakel);
    formData.append("AgencyNumber", NumberTawkel + "-" + Cahr + "-" + Year);
    formData.append("AgencyDate", DateTawkel);
    formData.append("AgencyPurpose", Gharad);
    formData.append(
      "ClientId",
      NameMowakel && NameMowakel.Id !== 0 ? NameMowakel.Id : ""
    );
    formData.append(
      "AgencyTypeId",
      TypeTwakel && TypeTwakel.Id !== 0 ? TypeTwakel.Id : ""
    );
    formData.append(
      "AgencyStatusId",
      TawkelStatus && TawkelStatus.Id !== 0 ? TawkelStatus.Id : ""
    );
    formData.append(
      "AgencyDestinationId",
      Gehaa && Gehaa.Id !== 0 ? Gehaa.Id : ""
    );
    formData.append("NewFile", selectedFile);
    formData.append("FileDescription", NoteImg);

    await dispatch(UpdateAgencyAction(formData));
    setSefaMowakel("");
    setNote("");
    setNameWakel("");
    setNameMowakel("");
    setDateTawkel("");
    setGharad("");
    setYear("");
    setCahr("");
    setNumberTawkel("");
    setTypeTwakel("");
    setTawkelStatus("");
    setGehaa("");
    setSelectedFile("");
    setBase64("");
    setIsEdit(false);
    setIsPress(false);
    setLoading(false);
  };

  const Update = (item) => {
    setSefaMowakel(item.AgencyDescription || "");
    setNameWakel(item.AgencyName || "");
    setTawkelID(item.Id);
    setNoteImg(item.FileDescription || "");
    setNameMowakel({
      Name: item.ClientDto?.Name ? item.ClientDto.Name : "",
      Id: item.ClientDto?.Id ? item.ClientDto?.Id : "",
    });

    setDateTawkel(item.AgencyDate);
    setGharad(item.AgencyPurpose || "");
    setTypeTwakel({
      Name: item.AgencyTypeDto?.Name ? item.AgencyTypeDto?.Name : "",
      Id: item.AgencyTypeDto?.Id ? item.AgencyTypeDto?.Id : "",
    });
    setTawkelStatus({
      Status: item.AgencyStatusDto?.Status ? item.AgencyStatusDto?.Status : "",
      Id: item.AgencyStatusDto?.Id ? item.AgencyStatusDto?.Id : "",
    });
    setGehaa({
      Name: item.AgencyDestinationDto?.Name
        ? item.AgencyDestinationDto?.Name
        : "",
      Id: item.AgencyDestinationDto?.Id ? item.AgencyDestinationDto?.Id : "",
    });
    setNumberTawkel(() => converterqoma(item?.AgencyNumber)[0]);
    setCahr(() => converterqoma(item?.AgencyNumber)[1]);
    setYear(() => converterqoma(item?.AgencyNumber)[2]);
    setSelectedFile(item.FileUrl);
    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setSefaMowakel(item.AgencyDescription || "");
    setNameWakel(item.AgencyName || "");
    setTawkelID(item.Id);
    setNoteImg(item.FileDescription === null ? "" : item.FileDescription);
    setNameMowakel({
      Name: item.ClientDto?.Name ? item.ClientDto?.Name : "",
      Id: item.ClientDto?.Id ? item.ClientDto?.Id : "",
    });

    setDateTawkel(item.AgencyDate);
    setGharad(item.AgencyPurpose || "");
    setTypeTwakel({
      Name: item.AgencyTypeDto?.Name ? item.AgencyTypeDto?.Name : "",
      Id: item.AgencyTypeDto?.Id ? item.AgencyTypeDto?.Id : "",
    });
    setTawkelStatus({
      Status: item.AgencyStatusDto?.Status ? item.AgencyStatusDto?.Status : "",
      Id: item.AgencyStatusDto?.Id ? item.AgencyStatusDto?.Id : "",
    });
    setGehaa({
      Name: item.AgencyDestinationDto?.Name
        ? item.AgencyDestinationDto?.Name
        : "",
      Id: item.AgencyDestinationDto?.Id ? item.AgencyDestinationDto?.Id : "",
    });
    setNumberTawkel(() => converterqoma(item?.AgencyNumber)[0]);
    setCahr(() => converterqoma(item?.AgencyNumber)[1]);
    setYear(() => converterqoma(item?.AgencyNumber)[2]);
    setSelectedFile(item.FileUrl);
    setIsEdit(false);
    setEye(true);
  };

  const res = useSelector((state) => state.AgencyR.InsertAgency);
  const UP = useSelector((state) => state.AgencyR.UpdateAgency);
  const DEL = useSelector((state) => state.AgencyR.DeleteAgency);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage === "Great, Agency created Successfully"
          ) {
            dispatch(GetAllAgencyAction(`PageSize=${PageSize}`));
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage === "Great, agency updated successfully"
          ) {
            dispatch(GetAllAgencyAction(`PageSize=${PageSize}`));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, agency deleted Successfully"
          ) {
            dispatch(GetAllAgencyAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            {/* <div className="inp-container">
              <div className=" ss">
                <TextField
                  
                  label="المسلسل"
                  variant="outlined"
                  //   className="ww"
                />
              </div>
            </div> */}
            <div className="inp-container">
              {/* <Autocomplete
                multiple
                // value={NameMowakel}
                onChange={(e, v) => setNameMowakel(v)}
                id="tags-outlined"
                options={
                  ALLMowakel &&
                  ALLMowakel.data !== undefined &&
                  ALLMowakel.data.length > 0
                    ? ALLMowakel.data 
                    : []
                }
                getOptionLabel={(option) => option.name}
                // defaultValue={[names[13]]}

                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}
                      >
                        اسم الموكل
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    // placeholder="Favorites"
                  />
                )}
              /> */}
              <Autocomplete
                value={NameMowakel}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setNameMowakel({
                      Name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setNameMowakel({
                      Name: newValue.inputValue,
                    });
                  } else {
                    setNameMowakel(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.Name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  ALLMowakel &&
                  ALLMowakel.Data !== undefined &&
                  ALLMowakel.Data.length > 0
                    ? ALLMowakel.Data
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Name}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموكل
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowName}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label="صفة الموكل"
                variant="outlined"
                value={SefaMowakel}
                onChange={(e) => setSefaMowakel(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="اسم الوكيل"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={NameWakel}
                onChange={(e) => setNameWakel(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <div className="inp-main">
                <div className="seris">
                  <TextField
                    label={"رقم التوكيل"}
                    variant="outlined"
                    inputProps={{ maxLength: 15 }}
                    type="number"
                    value={NumberTawkel}
                    onChange={(e) => setNumberTawkel(e.target.value)}
                    //   className="ww"
                  />
                </div>
                <div className="numm">
                  <TextField
                    label="الحرف"
                    inputProps={{ maxLength: 120 }}
                    type="text"
                    value={Cahr}
                    onChange={(e) => setCahr(e.target.value)}
                    variant="outlined"
                    //   className="ww"
                  />
                </div>
                <div className="year">
                  <TextField
                    label="السنة"
                    inputProps={{ maxLength: 15 }}
                    type="number"
                    value={Year}
                    onChange={(e) => setYear(e.target.value)}
                    variant="outlined"
                    //   className="ww"
                  />
                </div>
              </div>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={TypeTwakel}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setTypeTwakel({
                      Name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setTypeTwakel({
                      Name: newValue.inputValue,
                    });
                  } else {
                    setTypeTwakel(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.Name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={ALLType && ALLType.length > 0 ? ALLType : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Name}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label={"نوع التوكيل"} />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowTypet}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={Gehaa}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setGehaa({
                      Name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setGehaa({
                      Name: newValue.inputValue,
                    });
                  } else {
                    setGehaa(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.Name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={ALLGeha && ALLGeha.length > 0 ? ALLGeha : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Name}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label={"جهة التوثيق"} />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowVerify}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <div className="dateee">
                {DateTawkel
                  ? new Date(DateTawkel).toLocaleDateString("en-GB")
                  : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="تاريخ التوكيل"
                variant="outlined"
                type="date"
                value={DateTawkel}
                onChange={(e) => setDateTawkel(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <TextField
                label="الغرض من التوكيل"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Gharad}
                onChange={(e) => setGharad(e.target.value)}
                //   className="ww"
              />
            </div>

            <div className="inp-container">
              <Autocomplete
                value={TawkelStatus}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setTawkelStatus({
                      Name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setTawkelStatus({
                      Name: newValue.inputValue,
                    });
                  } else {
                    setTawkelStatus(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.Name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={ALLStatus && ALLStatus.length > 0 ? ALLStatus : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Status;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Status}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label="حالة التوكيل" />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowState}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <TextField
                label="أرشيف المستندات"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                //   className="ww"
                onChange={(e) => setNoteImg(e.target.value)}
                value={NoteImg}
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              {selectedFile && (
                <div className="fi">
                  <a
                    href={FileeBase64 ? FileeBase64 : selectedFile}
                    target="blank"
                    download={selectedFile.name}>
                    {selectedFile.name ? (
                      selectedFile.name
                    ) : (
                      <i
                        className=" fa-solid fa-paperclip"
                        style={{ color: "#1866ec" }}></i>
                    )}
                  </a>
                  <div style={{ display: "block" }}>Attach File</div>
                  <button
                    style={{ background: "transparent" }}
                    className="buttonadd d">
                    <i
                      onClick={(idx) => deleteFile(idx)}
                      className="fs fa-solid fa-trash-can icon-red"
                      style={{ color: "red" }}></i>
                  </button>
                </div>
              )}
            </div>

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
        </Container>{" "}
        <div>
          <Table
            ref={tableRef}
            id="my-table"
            className="maint"
            responsive
            striped
            bordered
            hover>
            <thead>
              <tr>
                <th>
                  اسم الموكل <i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  رقم التوكيل <i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  نوع التوكيل <i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  جهة التوثيق <i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  ارشيف المستندات{" "}
                  <i className="fa-regular fa-calendar-check"></i>
                </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
              </tr>
            </thead>
            <tbody>
              {ALL && ALL.Data && ALL.Data.length > 0
                ? ALL.Data.map((item, idx) => {
                    // ForceCount = ALL.TotalPages - 1;
                    return (
                      <tr key={idx} onDoubleClick={() => Update(item)}>
                        <td>{item.ClientDto?.Name}</td>
                        <td>
                          {item.AgencyNumber !== null
                            ? converterqoma(item.AgencyNumber)[0]
                            : ""}
                        </td>
                        <td>{item.AgencyTypeDto?.Name}</td>
                        <td>{item.AgencyDestinationDto?.Name}</td>
                        <td>
                          {" "}
                          {item.FileUrl !== null ? (
                            <>
                              <button
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                                onClick={() => handleShowpopup(item.FileUrl)}>
                                {" "}
                                <i className="fa-solid fa-paperclip"></i>
                              </button>
                              <span>{item.FileDescription}</span>
                            </>
                          ) : (
                            " "
                          )}
                        </td>
                        <td className="icon-w" onClick={() => Update(item)}>
                          <i
                            className="fa fa-solid fa-pen-to-square icon-blue"
                            style={{ color: "#333" }}></i>
                        </td>
                        <td className="icon-w">
                          {" "}
                          <i
                            onClick={() => handleShoweDelete(item.Id)}
                            className="fs fa-solid fa-trash-can icon-red"
                            style={{ color: "#333" }}></i>
                        </td>
                        <td className="icon-w">
                          <i
                            onClick={() => Showw(item)}
                            className="fa-solid fa-eye"
                            style={{ color: "#333" }}></i>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </Table>
        </div>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={ALL ? ALL.TotalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        {/* <Pagination
          onPress={onPress}
          // PageSize={PageSize}
          PageCount={ALL ? ALL.totalCount : null} 
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        /> */}
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <Modal
        show={showName}
        onHide={handleCloseName}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة الموكلين</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Namemowakel userData={userData} />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseName}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showTypet}
        onHide={handleCloseTypet}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة انواع التوكيلات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Typemowkel />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseTypet}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showVerify}
        onHide={handleCloseVerify}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة جهات التوثيق </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Geha />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseVerify}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showState}
        onHide={handleCloseState}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة حالات التوكيل</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Tawkelstate />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseState}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>

      {/* <Modal
        show={showPdf}
        onHide={handleClosePdf}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>بيانات التوكيل</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={myDivRefWorkcom}>
            <TawkelPrint
              NameMowakel={NameMowakel}
              SefaMowakel={SefaMowakel}
              TawkelStatus={TawkelStatus}
              NameWakel={NameWakel}
              Gharad={Gharad}
              NumberTawkel={NumberTawkel}
              TypeTwakel={TypeTwakel}
              Gehaa={Gehaa}
              DateTawkel={DateTawkel}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleClosePdf}>
            إغلاق
          </Button>
          <Button
            onClick={handlePrint}
            variant="primary"
            className="edit">
            طباعة
          </Button>
        </Modal.Footer>
      </Modal> */}

      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div ref={myDivRefWorkcom}>
        <TawkelPrint
          NameMowakel={NameMowakel}
          SefaMowakel={SefaMowakel}
          TawkelStatus={TawkelStatus}
          NameWakel={NameWakel}
          Gharad={Gharad}
          NumberTawkel={NumberTawkel}
          TypeTwakel={TypeTwakel}
          Gehaa={Gehaa}
          DateTawkel={DateTawkel}
        />
      </div>
    </>
  );
};
export default Enter;
